<div #outsideModalCor class="modal">
    <div #modalBodyCor class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            
            <div class="correpondant-container">
                <div class="select-table-container">
                    <frg-table #table1 [keysBody]="selectBodyTable" [keysColumn]="selectColumnTable"
                        tableButton1="assets/icons/trash.svg" (onClick1)="deleteCorrespondant($event)" class='table'>
                    </frg-table>
                   
                </div>
                <div class="correspondant-table-container">
                    <frg-search-input #searchInput (search)="filterCorrespondants($event)"></frg-search-input>

                    <frg-table #table4 [keysBody]="correspondantsBodyTable" [keysColumn]="correspondantsColumnTable"
                        class="table" [tableButton2]="'assets/icons/previous.svg'"
                        (onClick2)="selectCorrespondant($event)">
                    </frg-table>
                    <frg-table #table2 [keysBody]="correspondantsPatientBodyTable" [keysColumn]="correspondantsPatientColumnTable"
                        class="table" [tableButton2]="'assets/icons/previous.svg'"
                        (onClick2)="selectCorrespondant($event)">
                    </frg-table>
                    
                </div>
               
            </div>        
            
            <div class="button-wrapper">
                <frg-button 
                    [backgroundColor]="'var(--darkest-primary)'" [type]="'reset'" [disabled]="this.selectBodyTable.objects.length === 0" (click)="validateCorrespondant()">
                    Valider le(s) correspondant(s)
                </frg-button>
                <frg-button 
                    [backgroundColor]="'var(--darkest-primary)'" [type]="'reset'" (click)="closeModal()">
                    Annuler
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>